import { DEFAULT_LOCALE } from '../../constants';

/**
 * Determines if a translation Button should be displayed
 * @param {string} [locale=DEFAULT_LOCALE] The current locale.
 * @param {string} sourceLanguage The language of the review.
 * @returns {boolean} `true` if a translation should be displayed, `false` otherwise.
 */
export const shouldDisplayTranslation = (locale = DEFAULT_LOCALE, sourceLanguage) =>
    locale !== DEFAULT_LOCALE && (!sourceLanguage || !locale.includes(sourceLanguage));

export const isTranslationPresent = (reviews, locale) =>
    reviews.some((review) => shouldDisplayTranslation(locale, review.comment_language));
